import {createContext} from 'react'

export enum PipelinesTarget {
  DETAILS_POPUP,
  DETAILS_SIDEBAR,
  JOB_DEBUG_POPUP,
  JOB_DEBUG_PANEL,
}

export const PipelinesTargetContext = createContext<PipelinesTarget | null>(null)
